import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { MFA_METHOD } from '@client-hub/shared/constants'
import { VerifyMfaCodePayload } from '@client-hub/store/api/crs/types'
import { useVerifyMfaCodeMutation } from '@client-hub/store/api/crs/react'
import MfaAuth, { MfaAuthContentType } from 'components/Mfa/Auth'
import { AuthCodeSchema } from 'schemas/mfa'
import { handleAuthCodeChange } from 'utils/mfa'
import { useMfaNavigateState, useRedirect } from 'hooks'
import ROUTES from '@client-hub/shared/constants/routes'
import { useTranslation } from 'react-i18next'

const MfaEditCode = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const [verifyMfaCode, { isSuccess, data }] = useVerifyMfaCodeMutation()
  const { uid, sms_status, two_factor_auth, phone_number, from, isAllowedMfa } = useMfaNavigateState()
  const smsMessage = sms_status?.['message'] || ''

  useRedirect(!isAllowedMfa)

  const content: MfaAuthContentType = {
    back: { name: t('routes.mfaAuth.global.back') },
    placeholder: t('forms.mfaAuth.fields.authCode.placeholder'),
    label: two_factor_auth === MFA_METHOD.AUTHENTICATOR_APP ? t('routes.mfaAuth.auth.labelSetup') : smsMessage,
    subText: two_factor_auth === MFA_METHOD.AUTHENTICATOR_APP ? t('routes.mfaAuth.auth.subtext') : '',
    showQrCode: two_factor_auth === MFA_METHOD.AUTHENTICATOR_APP,
  }

  useEffect(() => {
    if (isSuccess && data) {
      const {
        results: { backup_codes },
      } = data
      const state = { from, backup_codes, isAllowedMfa: true }
      navigate(ROUTES.MFA.EDIT.BACKUP_CODES, { state, replace: true })
    }
  }, [data, from, isSuccess, navigate])

  const onSubmit = useCallback(
    (code: string) => {
      const requestData: VerifyMfaCodePayload = {
        uid,
        two_factor_auth,
        totp: code,
        setup: '1',
        ...(two_factor_auth === MFA_METHOD.SMS && { phone_number }),
      }
      verifyMfaCode(requestData)
    },
    [phone_number, two_factor_auth, uid, verifyMfaCode],
  )

  if (!isAllowedMfa) return null

  return <MfaAuth content={content} schema={AuthCodeSchema} onChange={handleAuthCodeChange} onSubmit={onSubmit} />
}

export default MfaEditCode
